/**
 * Options for when a package is linked in the resolve map.
 */
export type LinkOptions = {
  /**
   * Controls the behavior of duplicated dependencies in the resolve map when running `cloudpack link`.
   *
   * - `allow-duplication` (default): allow multiple versions of the same package to exist in the
   *   resolve map to satisfy semver.
   * - `force-host-version`: the package will be deduplicated to the version of the host package,
   *   ignoring semver requirements.
   * - `force-remote-version`: the package will be deduplicated to the version of the remote package,
   *   ignoring semver requirements.
   *
   * Note: These settings only apply when the resolve strategy is set to the default `dedupe`.
   */
  duplicatedDependencyBehavior?: 'force-host-version' | 'allow-duplication' | 'force-remote-version';
};
